import { NgModule } from "@angular/core";
import { MobileRoutingModule } from "./mobile-routing.module";
import { SharedModule } from "../shared/shared.module";
import { InitMobileComponent } from "./init-mobile/init-mobile.component";
import { MobileDownloadComponent } from "./mobile-download/mobile-download.component";

@NgModule({
  imports: [SharedModule, MobileRoutingModule],
  declarations: [InitMobileComponent, MobileDownloadComponent],
})
export class MobileModule {}
